<template>
  <b-table
    :fields="fieldsInstrument"
    :items="GET_INSTRUMENTS_MODEL_VARIANT.results"
    show-empty
    responsive
    hover
    :empty-text="$t('empty_text')"
    @row-clicked="$emit('row-selected', $event)"
  >
    <template #head()="props">
      <span>{{ $t(props.label) }}</span>
    </template>

    <template #cell(actions)="data">
      <div>
        <b-button
          variant="outline-primary"
          class="ml-50 mt-50 mb-50"
          size="sm"
          @click="$emit('on-click-reset', data.item)"
        >
          {{$t('return')}}
        </b-button>
      </div>
    </template>
  </b-table>
</template>

<script>
import { BTable, BButton } from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    BTable,
    BButton,
  },
  data: () => ({
    fieldsInstrument: [
      {
        label: '№',
        key: 'id',
      },
      {
        label: 'reference.categoriya',
        key: 'type.category.title',
      },
      {
        label: 'reference.name',
        key: 'type.title',
      },
      {
        label: 'model',
        key: 'title',
      },
      {
        label: 'amount',
        key: 'remainder',
      },
      {
        label: 'actions',
        key: 'actions',
      },
    ],
  }),
  computed: {
    ...mapGetters('instruments', ['GET_INSTRUMENTS_MODEL_VARIANT']),
  },
}
</script>

<style>

</style>
